import React from "react";
import { useSelector } from "react-redux";
import SubmittedTaskListings from "../../components/hygiene-system/submitted-tasks/SubmittedTaskListings";
import { selectUser } from "../../components/auth/auth.selector";

const HygineSubmittedTasks = () => {
  const userInfoData = useSelector(selectUser);

  return <SubmittedTaskListings userInfoData={userInfoData} />;
};

export default HygineSubmittedTasks;
